import { render, staticRenderFns } from "./AssetDepartaments.vue?vue&type=template&id=09304530"
import script from "./AssetDepartaments.vue?vue&type=script&lang=js"
export * from "./AssetDepartaments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports